import { Modal, Typography } from '@getsynapse/design-system';
import { ModalProps } from '@getsynapse/design-system/dist/Organisms/Modal/Modal';
import intl from 'react-intl-universal';

export type DeleteBudgetModalProps = ModalProps & {
  onDeleteBudget: () => void;
  onCancel: () => void;
  title: string;
};

export const DeleteBudgetModal = ({
  onDeleteBudget,
  onCancel,
  title,
  ...props
}: DeleteBudgetModalProps) => {
  return (
    <Modal
      {...props}
      data-cy='delete-budget-modal'
      aria-label={intl.get('BUDGET_PAGE.DELETE_BUDGET_MODAL.TITLE', {
        title: title,
      })}
      titleIcon={{
        name: 'trash',
        className: 'text-error',
      }}
      title={intl.get('BUDGET_PAGE.DELETE_BUDGET_MODAL.TITLE')}
      size='small'
      actionButtons={[
        {
          children: intl.get('BUDGET_PAGE.DELETE_BUDGET_MODAL.CONFIRM'),
          onClick: onDeleteBudget,
          'data-cy': 'remove-budget_button',
          variant: 'primary',
          color: 'danger',
        },
        {
          children: intl.get('CANCEL'),
          variant: 'tertiary',
          onClick: onCancel,
          'data-cy': 'cancel-budget_button',
        },
      ]}
    >
      <Typography className='mb-4'>
        {intl.get('BUDGET_PAGE.DELETE_BUDGET_MODAL.CAPTION', { title: title })}
      </Typography>
      <Typography>
        {intl.get('BUDGET_PAGE.DELETE_BUDGET_MODAL.WARNING')}
      </Typography>
    </Modal>
  );
};
